




















import Vue from 'vue';
import { sanityClient, urlFor } from '@/config/sanity';
import Story from '@/models/story';
import LoadingIndicator from '@/components/LoadingIndicator.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import StoriesPanel from '@/components/StoriesPanel.vue';
import SpeakerWithGradient from '@/components/SpeakerWithGradient.vue';

interface Data {
  isLoading: boolean;
  error: string;
  stories: Array<Story>;
}

export default Vue.extend({
  name: 'Stories',
  components: {
    LoadingIndicator,
    ErrorMessage,
    StoriesPanel,
    SpeakerWithGradient,
  },
  data(): Data {
    return {
      isLoading: true,
      error: '',
      stories: [],
    };
  },
  created() {
    this.fetchStories();
  },
  methods: {
    urlFor,
    fetchStories() {
      this.isLoading = true;
      const query = `*[_type == "story"] | order(_createdAt desc) {
        "createdAt": _createdAt,
        "updatedAt": _updatedAt,
        "id": _id,
        "key": _key,
        "slug": slug.current,
        title,
        excerpt,
        image,
        author,
        department,
        publishedDate,
        updatedDate
      }`;

      return sanityClient.fetch(query).then(
        (results) => {
          this.stories = results;
          this.isLoading = false;
        },
        (error) => {
          this.error = error;
          this.isLoading = false;
        },
      );
    },
  },
});
